import chroma from 'chroma-js';
import { getNewElementId, updateMultipleElements } from '../actions/elementActions';
import { getElementId, getTags } from '../../../common/elements/utils/elementPropertyUtils';
import { ImMNElement } from '../../../common/elements/elementModelTypes';
import { toArray } from '../../../common/utils/immutableHelper';
import { createTag } from '../../../common/tags/tagActions';
import { Tag, TagCreationData } from '../../../common/tags/tagTypes';
import { Thunk } from '../../types/reduxTypes';

export const addTagToElements = (elements: Immutable.List<ImMNElement>, tagId: string) => {
    const updates = toArray(
        elements.map((element) => {
            const elementTags = getTags(element) || [];
            if (elementTags.includes(tagId)) return null;

            return {
                id: getElementId(element),
                changes: {
                    tags: [...elementTags, tagId],
                },
            };
        }),
    )?.filter(Boolean);

    return updateMultipleElements({ updates });
};

export const removeTagFromElements = (elements: Immutable.List<ImMNElement>, tagId: string) => {
    const updates = toArray(
        elements.map((element) => {
            const elementTags = getTags(element) || [];
            if (!elementTags.includes(tagId)) return null;

            return {
                id: getElementId(element),
                changes: {
                    tags: elementTags.filter((id: string) => id !== tagId),
                },
            };
        }),
    )?.filter(Boolean);

    return updateMultipleElements({ updates });
};

const createNewTagThunk =
    (tagData: TagCreationData): Thunk<Tag> =>
    (dispatch: Function) => {
        const id = dispatch(getNewElementId());

        const { name, creator, rootBoardIds } = tagData;
        const tag = {
            id,
            name,
            rootBoardIds,
            color: chroma.random().hex(),
            meta: {
                creator,
                createdTime: Date.now(),
                modifiedTime: Date.now(),
            },
        };

        dispatch(createTag(tag));
        return tag;
    };

export const createAndAddTagToElementsThunk =
    (tagData: TagCreationData, elements: Immutable.List<ImMNElement>): Thunk =>
    (dispatch: Function) => {
        const newTag = dispatch(createNewTagThunk(tagData));
        dispatch(addTagToElements(elements, newTag.id));
    };
